// Realtime SDK subscription to the whole DB root.
// Used on the INSTRUCTOR view for instant updates (1-2 active websockets total).

import { useEffect, useState } from 'react'
import { subscribe } from '../firebase/realtime.js'

export function useRealtimeRoot() {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const unsub = subscribe('/', setData, setError)
    return unsub
  }, [])

  // Pre-derive useful shapes
  const safe = data || {}
  const venue = { open: false, opened_at: null, closed_at: null, ...(safe.venue || {}) }
  const rooms = safe.rooms || {}
  const requests = Object.entries(safe.requests || {})
    .map(([id, r]) => ({ id, ...r, voteCount: r.votes ? Object.keys(r.votes).length : 0 }))
  const played = Object.entries(safe.played_tonight || {})
    .map(([id, p]) => ({ id, ...p }))
    .sort((a, b) => (b.played_at || 0) - (a.played_at || 0))
  const instructors = safe.instructors || {}

  return { venue, rooms, requests, played, instructors, error }
}
